

















































import {Component, Vue} from "vue-property-decorator";
import PayrollService from "@/services/payroll/PayrollService";
import PayrollFileCategories from "@/constants/PayrollFileCategories";
import FileUpload from "@/components/common/FileUpload.vue";
import RouteNames from "@/router/RouteNames";
import CollapsedPaystubReport from "@/components/payroll/reports/paystub/CollapsedPaystubReport.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import CollapsedPayrollDetailsReport
	from "@/components/payroll/reports/payroll_details/CollapsedPayrollDetailsReport.vue";
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import EmployeeDto from "@/dto/payroll/EmployeeDto";
import {PayrollReportFilter} from "@/dto/payroll/PayrollReportFilter";
import Application from "@/state/Application";
import EmploymentService from "@/services/EmploymentService";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import {processError} from "@/utils/ComponentUtils";

@Component({
  components: {CollapsedPayrollDetailsReport, PaginationComponent, PortalDate, CollapsedPaystubReport, FileUpload}
})
export default class BusinessPayrollDetails extends Vue {

	private payrolls: Array<PayrollReport> = [];

	private employee: EmployeeDto | null = null;

	private filter = new PayrollReportFilter()

	private totalPages = 0;

	mounted() {
		if (!this.$route.params.personId) {
			this.$router.push({
				name: RouteNames.PAYROLL_BUSINESS_EMPLOYEES,
				params: {companyId: this.$route.params.companyId, then: PayrollFileCategories.PAYSTUB}
			});
		} else {
			Application.startLoading()
			this.loadPerson()
				.then(this.initFilter)
				.then(this.loadReports)
				.finally(Application.stopLoading)

		}
	}

	loadPerson() {
		return EmploymentService.getAllByFilter<EmployeeDto>(
			new EmploymentFilter(
				{
					status: [EmploymentStatus.ACTIVE, EmploymentStatus.NEW, EmploymentStatus.PENDING_FOR_DOCUMENTS],
					detailsId: Number.parseInt(this.$route.params.personId, 10),
					employerId: Number.parseInt(this.$route.params.companyId, 10),
					types: ["STAFF"]
				}
			)
		).then(
			response => {
				this.employee = response.data[0];
			},
			err => processError(err, this)
		)
	}

	private resetFilter() {
		this.filter.startDate = null
		this.filter.endDate = null;
		this.filter.page = 0;
	}

	private initFilter() {
		this.filter.employeeId = this.employee!.details.id
		this.filter.employerId = this.employee!.employer.id
		this.filter.employmentId = this.employee!.id
		return Promise.resolve()
	}

	private loadReports(): Promise<void> {
		return PayrollService.getPayrollDetailsPageByFilter(this.filter).then(
			(response) => {
				this.payrolls = response.data.data;
				this.totalPages = response.data.countOfPages
			},
			err => processError(err, this)
		);
	}

}
